import { ImageUp } from "lucide-react";

export function ImageSlots({ images, edits, onReplace, busyKey }) {
  if (!images?.length) return null;
  return (
    <div className="space-y-2" data-testid="nl-image-slots">
      <p className="text-xs text-brand-muted">Template images <span className="text-brand-tertiary">(click to replace)</span></p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {images.map((im) => {
          const src = edits[im.key]?.src || im.src;
          return (
            <button key={im.key} type="button" onClick={() => onReplace(im)} disabled={busyKey === im.key} data-testid={`nl-image-slot-${im.key}`}
              className="group relative rounded-md border border-brand-border bg-white overflow-hidden aspect-[4/3] hover:border-brand-primary transition-colors">
              <img src={src} alt={im.alt || ""} className="w-full h-full object-contain" />
              <span className="absolute inset-0 flex items-center justify-center gap-1.5 bg-brand-ink/60 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                <ImageUp className="h-4 w-4" /> {busyKey === im.key ? "Uploading…" : "Replace"}
              </span>
              {edits[im.key] && <span className="absolute top-1.5 left-1.5 text-[10px] bg-brand-primary text-white rounded px-1.5 py-0.5">New · unsaved</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
